export const TestResultSectionDataP642 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F82HmiReadingAtLabel',
                    label: 'HMI Reading after Test',
                    xs: 2,
                    height: '1.2rem',
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    labelWidth: '96%',
                    textAlign: 'left',
                    fontSize: '9pt',
                    fontWeight: '600',
                },
                {
                    key: 'F82HmiReadingAt',
                    value: formData.F82HmiReadingAt,
                    isRequired: true,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    marginBottom: '0',
                    labelWidth: '0',
                    width: '100%',
                    height: '1.2rem',
                    textAlign: 'center',
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 1
                },
                {
                    key: 'F83ProcessGaugeReadingAtLabel',
                    label: 'Process Gauge Reading after Test',
                    labelWidth: '97%',
                    xs: 3,
                    height: '1.2rem',
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    textAlign: 'end',
                    fontSize: '9pt',
                    fontWeight: '600',
                    borderBottom: '0',
                },
                {
                    key: 'F83ProcessGaugeReadingAt',
                    value: formData.F83ProcessGaugeReadingAt,
                    type: 'number',
                    maxLength: '10',
                    isRequired: true,
                    labelWidth: '0',
                    xs: 4,
                    height: '1.2rem',
                    padding: '0',
                    textAlign: 'center',
                    width: '100%',
                    marginLeft: '0.8px'
                },
            ]
        }]

});
